import Flickity from "flickity";

window.Flickity = window.flickity = Flickity;